const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** "2 Oct 2026". Fixed format so every month abbreviates the same way. */
export function formatPostDate(d: string): string {
	const date = new Date(d);
	if (Number.isNaN(date.getTime())) return d;
	return `${date.getUTCDate()} ${MONTHS[date.getUTCMonth()]} ${date.getUTCFullYear()}`;
}
